import { useState } from 'react';
import { Icon } from '../../Atoms/Icon';
import { TextSpan } from '../../Atoms/Text';
import { ServiceRequestForm } from './ServiceRequestForm';
import { LocationScope } from './serviceRequestModel';

interface ServiceRequestProps {
  ctaClassName: string;
  label?: string;
  showIcon?: boolean;
  dataCy?: string;
  location?: LocationScope;
}

/** The New Request link and the form it opens; with a `location` the form starts there and mounts on the first click. */
export function ServiceRequestLink({
  ctaClassName,
  label = 'New Request',
  showIcon = true,
  dataCy = 'new-service-request',
  location
}: ServiceRequestProps) {
  const [open, setOpen] = useState(false);
  const [opened, setOpened] = useState(false);

  const onOpen = () => {
    setOpened(true);
    setOpen(true);
  };

  const onClose = async () => {
    setOpen(false);
  };

  return (
    <>
      <TextSpan className="flex items-center space-x-2">
        {showIcon && <Icon type="plus" />}
        <button
          className={ctaClassName}
          data-cy={dataCy}
          onClick={onOpen}>
          {label}
        </button>
      </TextSpan>
      {(opened || !location) && (
        <ServiceRequestForm
          open={open}
          onClose={onClose}
          location={location}
        />
      )}
    </>
  );
}
